import React from 'react';
import clsx from 'clsx';
import { makeStyles } from 'react-scale/components/design-system/styles';
import SanitizedMarkdown from 'react-scale/components/design-system/SanitizedMarkdown/SanitizedMarkdown';
import { WorkflowHook } from 'react-scale/components/scalers/Sidebar/GuidedWorkflowPanel/useWorkflow';

const useStyles = makeStyles({
  instructionPanelLink: {
    display: 'flex',
    fontSize: '11px',
    lineHeight: '16px',
    fontWeight: 'bold',
    padding: '6px 8px',
    alignItems: 'center',
    color: 'rgba(22, 122, 251, 1)',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  tooltipDescription: {
    minHeight: 25,
    overflow: 'auto',
    padding: '0px 8px',

    // Base values are smaller.
    fontSize: '11px',
    lineHeight: '16px',
    fontWeight: 400,
    maxHeight: 450,
    '&.isCompleted': {
      opacity: 0.3,
    },
  },
});

interface DefaultToolTipBodyProps {
  workflowHook: WorkflowHook;
}

/**
 * Default ToolTip for GWFBar - Shows Current Step Name & Close Button
 */
const DefaultToolTipBody: React.FC<DefaultToolTipBodyProps> = props => {
  const classes = useStyles();

  const { toggleIsGuidedWorkflowInstructionsPanelOpen, workflowState } = props.workflowHook;
  const { currentStep } = workflowState;

  const isCompleted = workflowState.completedStepIds.includes(currentStep.id);
  const hasInstructions = currentStep.instructions || currentStep.instructions !== '';

  const instructionPanelPrompt = hasInstructions && (
    <div
      className={classes.instructionPanelLink}
      onClick={toggleIsGuidedWorkflowInstructionsPanelOpen}
    >
      Check More Guidance
    </div>
  );

  const defaultToolTip = (
    <>
      <div className={clsx(classes.tooltipDescription, { isCompleted })}>
        {currentStep.description && <SanitizedMarkdown text={currentStep.description} />}
      </div>
      <div>{instructionPanelPrompt}</div>
    </>
  );

  return <> {defaultToolTip}</>;
};

export default DefaultToolTipBody;
